import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../../lib/i18n";
import { ArrowRight, Sparkle, Crown, ChatCircle } from "@phosphor-icons/react";

const ITEMS = [
  {
    icon: Sparkle,
    titleKey: "categoryEntry",
    descKey: "categoryEntryDesc",
    priceFromIt: "da € 79",
    priceFromEn: "from € 79",
  },
  {
    icon: Crown,
    titleKey: "categoryPremium",
    descKey: "categoryPremiumDesc",
    priceFromIt: "da € 690",
    priceFromEn: "from € 690",
  },
  {
    icon: ChatCircle,
    titleKey: "categoryMembership",
    descKey: "categoryMembershipDesc",
    priceFromIt: "da € 49 / mese",
    priceFromEn: "from € 49 / month",
  },
];

export default function ShopPreview() {
  const { t, lang } = useI18n();

  return (
    <section
      data-testid="shop-preview-section"
      className="bg-white py-24 lg:py-32 border-t border-[#0A1428]/10"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-14">
          <div className="max-w-2xl">
            <p className="overline mb-5">{t.shop.overline}</p>
            <h2 className="font-serif text-4xl lg:text-5xl xl:text-6xl text-[#0A1428] leading-[1.1] tracking-tight font-medium">
              {t.shop.previewTitle}
            </h2>
            <p className="mt-6 text-[#4A5568] text-lg leading-relaxed">
              {t.shop.previewSubtitle}
            </p>
          </div>
          <Link
            to="/servizi-online"
            data-testid="shop-preview-cta"
            className="btn-secondary self-start"
          >
            {t.shop.viewAll}
            <ArrowRight size={16} weight="bold" />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {ITEMS.map((item, i) => {
            const Icon = item.icon;
            return (
              <Link
                key={i}
                to="/servizi-online"
                data-testid={`shop-preview-card-${i}`}
                className="group card-elegant block bg-[#F8F9FA] p-8"
              >
                <div className="w-12 h-12 bg-white border border-[#C5A059]/30 flex items-center justify-center mb-6 group-hover:border-[#C5A059] transition-colors">
                  <Icon size={22} weight="duotone" className="text-[#C5A059]" />
                </div>
                <h3 className="font-serif text-2xl text-[#0A1428] font-medium leading-tight">
                  {t.shop[item.titleKey]}
                </h3>
                <p className="mt-3 text-[#4A5568] leading-relaxed text-sm">
                  {t.shop[item.descKey]}
                </p>
                <div className="mt-6 pt-5 border-t border-[#0A1428]/10 flex items-center justify-between">
                  <span className="font-serif text-lg text-[#0A1428] font-semibold">
                    {lang === "en" ? item.priceFromEn : item.priceFromIt}
                  </span>
                  <ArrowRight
                    size={18}
                    weight="bold"
                    className="text-[#C5A059] group-hover:translate-x-1 transition-transform"
                  />
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
